
    import '/mnt/src/components/DateTimePicker/index.md?watch=parent';
    export const demoIndex = {
  ids: ["datetimepicker-demo-demo2","datetimepicker-demo-demo4"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/DateTimePicker/index.md?type=demo')
};